var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3785_11374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4629 44.7836H71.9912V45.3835H65.153V49.8984H71.5834V50.4982H65.153V55.4551H72.0696V56.055H64.4629V44.7836ZM72.6656 44.7836H73.4655L77.0101 49.7405L80.6331 44.7836L85.5609 38.4873L77.4649 50.2614L81.6368 56.055H80.8056L77.0101 50.7824L73.1989 56.055H72.3833L76.5866 50.2614L72.6656 44.7836ZM81.9348 45.3835V44.7836H90.514V45.3835H86.5616V56.055H85.8715V45.3835H81.9348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0439 44.7837H55.9066L67.8016 62.6285L62.8859 56.055L55.7654 45.6361L55.734 56.055H55.0439V44.7837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.442 55.2743C90.5847 55.2743 90.6888 55.1648 90.6888 55.0233C90.6888 54.8817 90.5847 54.7722 90.442 54.7722C90.3011 54.7722 90.1953 54.8817 90.1953 55.0233C90.1953 55.1648 90.3011 55.2743 90.442 55.2743ZM91.1201 54.6138C91.1201 55.0317 91.4206 55.3046 91.8587 55.3046C92.3253 55.3046 92.6073 55.0233 92.6073 54.5346V52.8143H92.2313V54.5329C92.2313 54.8042 92.0953 54.9491 91.8553 54.9491C91.6405 54.9491 91.4944 54.8143 91.4894 54.6138H91.1201ZM93.0991 54.5919C93.1259 55.0266 93.4868 55.3046 94.0239 55.3046C94.5979 55.3046 94.9571 55.0131 94.9571 54.5481C94.9571 54.1825 94.7523 53.9803 94.2555 53.864L93.9886 53.7983C93.6731 53.7242 93.5455 53.6248 93.5455 53.4512C93.5455 53.2322 93.7436 53.089 94.0407 53.089C94.3227 53.089 94.5174 53.2288 94.5526 53.4529H94.9185C94.8967 53.0435 94.5375 52.7554 94.0457 52.7554C93.517 52.7554 93.1645 53.0435 93.1645 53.4765C93.1645 53.8337 93.3643 54.046 93.8023 54.1488L94.1145 54.2246C94.4351 54.3004 94.5761 54.4116 94.5761 54.597C94.5761 54.8126 94.3546 54.9693 94.0524 54.9693C93.7285 54.9693 93.5036 54.8228 93.4717 54.5919H93.0991Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3785_11374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24.1379,
    fill: "white",
    transform: "translate(55 38.4312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.62dcadd074f538c3fc1155e3c212ec0c.svg";
export { ForwardRef as ReactComponent };